export const parseHiddenLocations = (value) =>
    (value || "")
        .split(",")
        .map((location) => location.trim().toLowerCase())
        .filter(Boolean);

export const getHiddenLocations = () => parseHiddenLocations(sessionStorage.getItem("hiddenLocations"));

export const isLocationRestricted = (location = "", hiddenLocations = getHiddenLocations()) => {
    if (sessionStorage.getItem("customerType") === "mainAdmin") return false;
    if (!hiddenLocations.length) return false;

    const locationTokens = location
        .split(",")
        .map((item) => item.trim().toLowerCase())
        .filter(Boolean);

    return hiddenLocations.some((hiddenLocation) => locationTokens.includes(hiddenLocation));
};

export const filterRestrictedJobs = (jobs = [], hiddenLocations = getHiddenLocations()) =>
    jobs.filter((job) => !isLocationRestricted(job.location, hiddenLocations));
